import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Tooltip from "@material-ui/core/Tooltip";
// @material-ui/icons
import FormatAlignLeft from "@material-ui/icons/FormatAlignLeft";
// core components

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Button from "components/CustomButtons/Button.jsx";

import brokers from "assets/img/Kinos/brokers.jpg";
import investors from "assets/img/Kinos/investors-bg.jpg";
import blog8 from "assets/img/bg7.jpg";
import relations from "assets/img/Kinos/relations.jpg"
import cardProject6 from "assets/img/Kinos/Brokers/card-project6.jpg";

import sectionPillsStyle from "assets/jss/material-kit-pro-react/views/blogPostsSections/sectionPillsStyle.jsx";
import descriptionStyle from "assets/jss/material-kit-pro-react/views/aboutUsSections/descriptionStyle.jsx";

function SectionPills({ ...props }) {
  const { classes } = props;
  return (
    <div className={classes.section}>



      <GridContainer>
        <GridItem xs={12} sm={4} md={4}>
          <Card
            raised
            background
            style={{ backgroundImage: "url(" + brokers + ")" }}
          >
            <CardBody background>
              <h6 className={classes.category}>BROKERS</h6>
              <a href="/brokers">
                <h3 className={classes.cardTitle}>
                  Brokers & Brokerage services, connecting investors and sellers
                </h3>
              </a>
              <p className={classes.category}>
                Kinos is always looking for opportunities for investors. We have big portfolio include single asset repositioning, corporate divestitures, joint venture programs, entity investments, development opportunities and debt deals. Assets may be acquired either individually or in portfolio transactions.
              </p>
              <Button round href="/brokers" color="danger">
                <FormatAlignLeft className={classes.icons} /> Read more
              </Button>
            </CardBody>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={4} md={4}>
          <Card
            raised
            background
            style={{ backgroundImage: "url(" + investors + ")" }}
          >
            <CardBody background>
              <h6 className={classes.category}>INVESTORS</h6>
              <a href="/investors">
                <h3 className={classes.cardTitle}>
                  First-class business, in a First-class way
                </h3>
              </a>
              <p className={classes.category}>
                We are committed to a distinctive culture and set of core values.
              </p>
              <p className={classes.category}>
                These values are reflected in our Business Principles, which emphasize placing our client's interests first, integrity,
                commitment to excellence and innovation, and teamwork.
              </p>
              <Button round href="/investors" color="danger">
                <FormatAlignLeft className={classes.icons} /> Read more
              </Button>
            </CardBody>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={4} md={4}>
          <Card
            raised
            background
            style={{ backgroundImage: "url(" + relations + ")" }}
          >
            <CardBody background>
              <h6 className={classes.category}>RELATIONSHIPS</h6>
              <a href="/relations">
                <h3 className={classes.cardTitle}>
                  We are ready to share our market knowledge and expertise with you in order to satisfy yours objectives.
                </h3>
              </a>
              <p className={classes.category}>
                Primary objective is the building of long-term relationships based on know-how, trust and confidentiality with major participants in each sector.
              </p>
              <Button round href="/relations" color="danger">
                <FormatAlignLeft className={classes.icons} /> Read more
              </Button>
            </CardBody>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={12} md={12}>
          <Card
            raised
            background
            style={{ backgroundImage: "url(" + cardProject6 + ")" }}
          >
            <CardBody background>
              <h6 className={classes.category}>Efficiency, security, confidentiality, integrity, transparency</h6>
              <a href="/register">
                <h3 className={classes.cardTitle}>
                  OPERATIONS GLOBAL NETWORK WITH TORUS
                </h3>
              </a>
              <p className={classes.category}>
                We greatly enjoy our working relationship with TORUS & PARTNERS NETWORK . They are always prepared and proactive, bringing new ideas to the table and executing at a high level. Strategies are well-conceived and always with our interests and objectives in mind.
              </p>
              <Button round href="/register" color="warning">
                <FormatAlignLeft className={classes.icons} /> Read more
              </Button>

            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}

export default withStyles(sectionPillsStyle)(SectionPills);
